﻿import { Model } from "@vuex-orm/core";
import { DateTime } from "luxon";
import {
  formatPortalDateMed,
} from "../../helper/portal-datetime-format";
import { clientEntity } from "./client-entity";

export interface invoiceEntity {
  invoiceId: string;
  name: string;
  invoiceNumber: string;
  reference: string;
  description: string;
  createdOn: string;
  createdById: number;
  clientId: number;
  dueDate: string;
  emailSentDate: string;
  statusId: number;
  statusCode: string;
  totalAmount: number;
  externalInvoiceId: string;
  invoiceTemplate: string;
  invoiceTemplateId: number;
  invoiceEmailTemplateId: number;
  xeroBrandingTemplateId: number;
  xeroBrandingTemplate: string;
  paidAmount: number;
  isEmailSent: boolean;
  tick: number;
  isFilled: boolean;
  isSelected: boolean;
  isChanged: boolean;
  isVisited: boolean;
}

export class invoiceEntity extends Model {
  static entity = "invoiceEntity";
  static primaryKey = "invoiceId";
  static fields() {
    return {
      invoiceId: this.string(""),
      name: this.attr(null),
      invoiceNumber: this.string(""),
      reference: this.attr(null),
      description: this.string(""),
      createdOn: this.string(""),
      createdById: this.number(0),
      clientId: this.number(0),
      dueDate: this.string(""),
      emailSentDate: this.attr(null),
      statusId: this.number(0),
      statusCode: this.string(""),
      totalAmount: this.number(0),
      invoiceTemplate: this.attr(null),
      invoiceTemplateId: this.number(0),
      invoiceEmailTemplateId: this.number(0),
      xeroBrandingTemplateId: this.attr(null),
      xeroBrandingTemplate: this.attr(null),
      paidAmount: this.attr(null),
      isEmailSent: this.boolean(false),
      tick: this.number(0),
      isFilled: this.boolean(false), //Will be used in Web only
      isSelected: this.boolean(false),
      isChanged: this.boolean(false),
      isVisited: this.boolean(false),
      externalInvoiceId: this.attr(null),
      paidStatus: this.string("-"),
      paymentLink: this.string("-"),
    };
  }

  static beforeSelect(records: any) {
    return records.filter((row: any) => row.invoiceId != "0");
  }

  get isExpired() {
    return DateTime.utc() > DateTime.fromISO(this.dueDate, { zone: "utc" });
  }

  get clientName() {
    let client = clientEntity.query().whereId(this.clientId).first();
    if (client != null) return client.clientName;
    return "Unassigned Client";
  }

  get customEmailSentDate() {
    if (this.emailSentDate != null && this.emailSentDate != "") {
      return formatPortalDateMed(this.emailSentDate);
    }
    return "";
  }

  get formattedDueDate() {
    return formatPortalDateMed(this.dueDate);
  }
}
